import { useSelector } from 'react-redux';

import CommonImage from '@components/CommonImage';

import SortingDropdown from '@features/favourites/components/SortingDropdown';
import {
	FAVOURITES_DETAILS_VIEW_TYPES,
	FAVOURITES_SORTING_OPTIONS
} from '@features/favourites/utils/favouriteUtil';
import Chip from '@features/filter/Chip';

const FavouriteDetailsTopFilter = ({
	allFavouritesForProducts,
	isSearchBoxHidden,
	setIsSearchBoxHidden,
	onChangeAllCheckAndSearchForStyle,
	defaultViewType,
	handleDefaultViewType,
	setIsPlayPresentation,
	onSelectOption,
	setPage,
	selectedSortingOption,
	setIsShowSidePanel,
	setIsShowDraft,
	draftedProducts,
	id,
	setShowFilter
}) => {
	const findSelectedViewTypeIcon = () => {
		return FAVOURITES_DETAILS_VIEW_TYPES.find((item) => item.code === defaultViewType)?.icon;
	};
	const filterFields = useSelector((store) => store?.filterFieldStore);
	const isShowChip = () => {
		if (
			filterFields?.DETAILS_PAGE_FILTERS?.referenceNumber?.length > 0 ||
			filterFields?.DETAILS_PAGE_FILTERS?.productIdList?.length > 0
		) {
			return false;
		}
		return (
			Object.keys(filterFields?.DETAILS_PAGE_FILTERS || {}).some(
				(key) => key !== 'referenceNumber' && filterFields?.DETAILS_PAGE_FILTERS[key]?.length > 0
			) || Object.keys(filterFields)?.length > 0
		);
	};

	return (
		<div className="filter-container-top filter-container-top-v2  d-block">
			<div className="d-flex justify-content-between align-items-center w-100">
				<div className="filters" onClick={() => setShowFilter((prev) => !prev)}>
					<div className="filter-toggle no-after pl-0">
						<CommonImage src={`/icons/filter24.svg`} alt="filter" />
						<span>Filter</span>
					</div>
					<span className="items-count semibold-14 gray_dark_02 mr-4">
						{allFavouritesForProducts?.totalElements} Items
					</span>
				</div>
				<div className="filter-actions favourite-filter-actions">
					<div className="form-group size32 m-0 search-filter filter-with-animation">
						<div className="with-icon right-icon">
							<input
								type="text"
								placeholder="Design name & No"
								name="searchForStyle"
								onChange={onChangeAllCheckAndSearchForStyle}
								autoComplete="off"
							/>
							<span
								className="right-icon"
								onClick={() => setIsSearchBoxHidden(!isSearchBoxHidden)}
							>
								<CommonImage src="/icons/search.png" alt="search" />
							</span>
						</div>
					</div>
					<div className="sort-button design-view-sort">
						<div className="dropdown show">
							<button
								className="btn btn-default dropdown-toggle gray_dark_02 regular-14 p-0 pr-2"
								type="button"
								data-toggle="dropdown"
								aria-expanded="true"
							>
								<CommonImage src={findSelectedViewTypeIcon()} alt="large" />
							</button>
							<ul
								className="dropdown-menu dropdown-menu-right shadow-4dp"
								x-placement="bottom-end"
							>
								{FAVOURITES_DETAILS_VIEW_TYPES.map((item) => (
									<li
										onClick={() => handleDefaultViewType(item?.code)}
										key={item.code}
										className={`${defaultViewType === item.code ? 'active' : ''}`}
									>
										<CommonImage src={item.icon} alt={item.title} />
										{item.title}
									</li>
								))}
								{parseInt(id) !== -1 && (
									<li onClick={() => setIsPlayPresentation(true)}>
										<CommonImage src="/icons/play-icon.svg" alt="Play presentation" />
										Play presentation
									</li>
								)}
							</ul>
						</div>
					</div>
					<div className="sort-button">
						<SortingDropdown
							onSelectOption={onSelectOption}
							setPage={setPage}
							selectedOption={selectedSortingOption?.title}
							sortingOptions={FAVOURITES_SORTING_OPTIONS}
						/>
					</div>
					<div className="add-new-design" onClick={() => setIsShowSidePanel(true)}>
						<button className="button text size32 px-0">
							<CommonImage src="/icons/add-round.svg" alt="add" />
							<span className="ml-1">Style</span>
						</button>
					</div>
					<div className="draft-Button" onClick={() => setIsShowDraft(true)}>
						<button className="button outline size32 ml-2 text-nowrap">
							Draft ({draftedProducts?.length || 0})
						</button>
					</div>
				</div>
			</div>
			<div className="filter-chip-container my-1">
				{isShowChip() && <Chip parentComponent="FAVOURITE_DETAILS" />}
			</div>
		</div>
	);
};

export default FavouriteDetailsTopFilter;
